import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ApiService } from './api.service';
import { UserResponseDto } from '@qc/shared/dto';

@Injectable({ providedIn: 'root' })
export class UserService extends ApiService {
    protected get basePath(): string {
        return '/users';
    }

    getProfile() {
        return this.get<UserResponseDto>('me');
    }

    register(email: string, firstName?: string, lastName?: string) {
        return this.post<{ message: string; user: UserResponseDto }>('register', {
            email,
            ...(firstName && { firstName }),
            ...(lastName && { lastName }),
        });
    }

    verifyEmail(token: string): Observable<void> {
        return this.getVoid(`register/verify-email/${token}`);
    }

    updateProfile(data: { firstName?: string; lastName?: string }): Observable<UserResponseDto> {
        return this.put<UserResponseDto>('me', data).pipe(
            map((response) => response.data),
        );
    }
}
